import styled from 'styled-components'

export const CheckboxContainer = styled.div`
  max-width: 384px;
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }

  div {
    height: 24px;
    margin-bottom: 4px;
  }
`
